@if (activeCaller$ | async; as activeCaller) {
  <div class="caller-context-users">
    @if (!!(errorMessage$ | async)) {
      <auro-popover placement="bottom" removespace>
        Unable to retrieve Caller Context details.
        <span class="disconnected" slot="trigger"></span>
      </auro-popover>
    }
    <app-caller-context-dropdown
      [activeCaller]="activeCaller$ | async"
      [callers]="callers$ | async"
      [callerCount]="callerCount$ | async"
      [activeCallerIndex]="activeCallerIndex$ | async"
      [isDisconnected]="!!(errorMessage$ | async)"
      [callerHasInfo]="callerHasInfo"
    ></app-caller-context-dropdown>
    <div class="active-caller-details quantum-metric-encrypt">
      @if (!!activeCaller?.millionMilerStatus && activeCaller?.millionMilerStatus !== '0') {
        <app-passenger-loyalty-icon
          [millionMiler]="activeCaller.millionMilerStatus"
          [large]="true"
          style="position: relative; top: -1.5px"
        />
      }
      @if (!!activeCaller?.tierStatus && activeCaller?.tierStatus !== 'Regular') {
        <app-passenger-loyalty-icon [tierStatus]="activeCaller.tierStatus" [large]="true" style="position: relative; top: -1.5px" />
      }
      @if (callerHasInfo(activeCaller)) {
        <app-passenger-alaska-bank-card class="caller-bank-card" [activeBankCards]="activeBankCards" />
      }
      @if (activeCaller?.confirmationCode) {
        <a (click)="openReservation(activeCaller.confirmationCode)" (keypress)="onKeyPress($event)">
          <div class="caller-context-link">
            <div class="auro-icon-text-placement">
              <auro-icon
                category="interface"
                name="reservation-stroke"
                accent
                [attr.customSize]="true"
                style="height: 16px; width: 16px; top: -2px; position: relative"
              ></auro-icon>
              <span> {{ activeCaller.confirmationCode }} </span>
            </div>
          </div>
        </a>
      }
      @if (activeCaller?.loyaltyNumber) {
        <app-passenger-loyalty-number
          class="caller-loyalty-number"
          [airlineCode]="activeCaller.airlineCode"
          [loyaltyNumber]="activeCaller.loyaltyNumber"
          [allowOpenProfile]="true"
          [applyCallerContextStyling]="true"
        >
        </app-passenger-loyalty-number>
      }
    </div>
  </div>
} @else {
  <div class="no-caller">Caller Context is on standby, patiently anticipating an incoming call/chat to show available details.</div>
}
